import React, { FC, useEffect } from "react";
import { FormControl } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import InputLabel, { InputLabelProps } from "@material-ui/core/InputLabel";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Select, { SelectProps } from "@material-ui/core/Select";
import useStyles from "Components/DP/DPSelect/styles";

export interface DPSelectProps extends SelectProps {
  inputLabel: string;
  inputLabelProps?: InputLabelProps;
  selectedIndex?: number;
  onIndexChanged: (index: number) => void;
}

const DPSelect: FC<DPSelectProps> = ({
  inputLabel,
  inputLabelProps,
  selectedIndex,
  onIndexChanged,
  ...rest
}) => {
  const inputLabelRef = React.useRef<HTMLLabelElement>(null);
  const [labelWidth, setLabelWidth] = React.useState(0);

  useEffect(() => {
    setLabelWidth(
      inputLabelRef.current !== null ? inputLabelRef.current.offsetWidth : 0
    );
  }, []);

  const classes = useStyles();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onSelectChange = (evt: any) => {
    onIndexChanged(parseInt(evt.target.value, 10));
  };

  const tagSuffix = inputLabel
    .replace(/([a-z])([A-Z])/g, "$1-$2")
    .replace(/\s+/g, "-")
    .toLowerCase();

  return (
    <FormControl variant="outlined" className={classes.formControl}>
      <InputLabel
        {...inputLabelProps}
        ref={inputLabelRef}
        htmlFor={`dp-select-${tagSuffix}`}
      >
        {inputLabel}
      </InputLabel>
      <Select
        classes={{
          icon: classes.icon,
        }}
        className={classes.select}
        value={selectedIndex}
        onChange={onSelectChange}
        IconComponent={ExpandMore}
        input={
          <OutlinedInput
            labelWidth={labelWidth}
            name={`dp-input-${tagSuffix}`}
            id={`dp-select-${tagSuffix}`}
            fullWidth
          />
        }
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 300,
              marginTop: 54,
              padding: 0,
            },
          },
          variant: "menu"
        }}
        {...rest}
      />
    </FormControl>
  );
};

export default DPSelect;
